import { getRoomState, hasFilter } from '../utils';

export const selectSearch = (state) => getRoomState(state).search;

export const selectFilter = (state) => getRoomState(state).filter;

export const selectExcluded = (state) => getRoomState(state).excludedRooms;

export const selectHasFilter = (state) => hasFilter(selectFilter(state));

export const selectHasSearchOrFilter = (state) => {
  return selectHasFilter(state) || Boolean(selectSearch(state).trim());
};
